import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-near-black py-10 px-4 border-t border-gray-800" data-id="element-24">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-25">
          <p className="text-gray-500 font-sans text-sm" data-id="element-26">
            © {new Date().getFullYear()} El Protocolo Anti-Inflamatorio. Todos
            los derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-27">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-sage font-sans text-sm transition-colors" data-id="element-28">
              Política de Privacidad
            </button>
            <span className="text-gray-700 text-xs" data-id="element-29">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-sage font-sans text-sm transition-colors" data-id="element-30">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-31">
        <p data-id="element-32">
          <strong data-id="element-33">Última actualización:</strong> Marzo 2026
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-34">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-35">
          Al realizar tu compra, recopilamos únicamente la información necesaria
          para procesar tu pedido: nombre, dirección de correo electrónico y
          datos de pago. No almacenamos información de tarjetas de crédito en
          nuestros servidores.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-36">
          2. Uso de la Información
        </h3>
        <p data-id="element-37">
          Utilizamos tu información exclusivamente para: entregar el producto
          digital adquirido, enviarte el comprobante de compra y, si lo
          autorizas, comunicarte actualizaciones relacionadas con el protocolo.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-38">
          3. Protección de Datos
        </h3>
        <p data-id="element-39">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-40">
          4. Compartición de Datos
        </h3>
        <p data-id="element-41">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. La única excepción son los proveedores de servicios de pago
          necesarios para procesar tu transacción.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-42">
          5. Cookies
        </h3>
        <p data-id="element-43">
          Este sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio de forma anónima.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-44">
          6. Tus Derechos
        </h3>
        <p data-id="element-45">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. Para ejercer estos derechos, puedes contactarnos
          a través de los canales indicados en tu correo de confirmación de
          compra.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-46">
        <p data-id="element-47">
          <strong data-id="element-48">Última actualización:</strong> Marzo 2026
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-49">
          1. Producto Digital
        </h3>
        <p data-id="element-50">
          El Protocolo Anti-Inflamatorio de 72 Horas es un producto digital
          informativo en formato PDF. Al completar tu compra, recibirás acceso
          inmediato al material a través de un enlace de descarga.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-51">
          2. Uso Personal
        </h3>
        <p data-id="element-52">
          El contenido adquirido es para uso personal y no comercial. Queda
          prohibida la reproducción, distribución o reventa del material sin
          autorización expresa por escrito.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-53">
          3. Descargo de Responsabilidad
        </h3>
        <p data-id="element-54">
          Este protocolo tiene fines informativos y educativos. No sustituye el
          consejo médico profesional, diagnóstico o tratamiento. Consulta
          siempre con un profesional de la salud antes de realizar cambios
          significativos en tu alimentación o estilo de vida.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-55">
          4. Resultados
        </h3>
        <p data-id="element-56">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos, ya que estos dependen de factores individuales
          como el estado de salud, la adherencia al protocolo y las condiciones
          personales.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-57">
          5. Política de Reembolso
        </h3>
        <p data-id="element-58">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. Si experimentas algún problema técnico
          con la descarga, contáctanos y te ayudaremos a resolverlo.
        </p>

        <h3 className="font-serif text-lg text-near-black mt-6 mb-2" data-id="element-59">
          6. Modificaciones
        </h3>
        <p data-id="element-60">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor desde su publicación en
          esta página.
        </p>
      </Modal>
    </>;
}